import React, { useEffect, useState } from 'react';
import Moment from 'moment';
import {toast} from "react-toastify";
import {Link, useParams} from "react-router-dom";
import StationAPI from "../../apis/stationApi/StationAPI";
import Pagination from "../assets/Pagination";
import TableLoader from "../loaders/TableLoader";
import PrinterStation from "./PrinterStation";
import {NumericFormat} from "react-number-format";


const RapportMounthlyConsuption = () => {

    let {city} = useParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);

    const [consumptions, setConsumptions] = useState([]);
    const [startAt, setStartAt] = useState("");
    const [endAt, setEndAt] = useState("");
    const [sources, setSources] = useState([]);


    const fetchRapportMounthlyConsuptions = async () => {
        try{
            const data = await StationAPI.getMyMounthlyConsumptions();
            setConsumptions(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement du rapport des entrées caisse  !");
        }
    };


    const [param, setSetting] = useState();

    const fetchSetting = async () => {
        try{
            const data =  await StationAPI.findSetting();
            setSetting(data);
        }catch(error){
            toast.error("Erreur lors du chargement des paramettres !");
        }
    };


    //Au chargement du composant on va chercher les buses
    useEffect(() => {
        fetchRapportMounthlyConsuptions();
        fetchSetting();
        return () => console.log("...");
    }, []);

    const handleChangeCurrentPage = page => {
        setCurrentPage(page);
    };

    //Gestion de la recherche
    const handleSearch = ({currentTarget}) => {
        setSearch(currentTarget.value);
        setCurrentPage(1);
    };

    const itemsPerPage = 500;

    const filteredConsumptions = consumptions.filter(
        t =>
            t.plaque.toLowerCase().includes(search.toLowerCase()) ||
            t.driver.toLowerCase().includes(search.toLowerCase()) ||
            t.motif.toLowerCase().includes(search.toLowerCase()) ||
            t.type.toLowerCase().includes(search.toLowerCase()) ||
            t.quantity.toString().toLowerCase().includes(search.toLowerCase())
    );

    //Pagination des données
    const paginatedConsumptions = Pagination.getData(
        filteredConsumptions,
        currentPage,
        itemsPerPage
    );

    //console.log(allFrets);

    let counter = 1;

    const handleStartedDate = ({currentTarget}) => {
        setStartAt(currentTarget.value);
        setCurrentPage(1);
    };

    const handleEndedDate = ({currentTarget}) => {
        setEndAt(currentTarget.value);
        setCurrentPage(1);
    };

    const handleBtns = () => {

        if(startAt !== "" && endAt === "") {
            const filtered = consumptions.filter(
                item => Moment(item.created_at).format("YYYY/MM/DD") === Moment(startAt).format("YYYY/MM/DD"));
            setConsumptions(filtered);
        } else if (startAt !== "" && endAt !== "") {
            const filtered = consumptions.filter(
                item => Moment(item.created_at).format("YYYY/MM/DD") >= Moment(startAt).format("YYYY/MM/DD")
                    && Moment(item.created_at).format("YYYY/MM/DD") <= Moment(endAt).format("YYYY/MM/DD"));
            setConsumptions(filtered);
        }else{
            const filtered = consumptions.filter(item=>
                Moment(item.created_at).format("YYYY/MM/DD") >= Moment(startAt).format("YYYY/MM/DD"));
            setConsumptions(filtered)
        }

    };


    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <h2 className="p-2 fw-bold text-success">Rapport de consommations</h2>
                        <div className="card-body">

                            <div className="row">
                                <div className="col-md-4">
                                    <label htmlFor="source" className="text-dark">Recherche</label>
                                    <div className="form-group mt-3">
                                        <input placeholder="Mot..." type="text" className="form-control" name={search} onChange={handleSearch}/>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group mt-3">
                                        <label htmlFor="ByAll" className="text-dark">
                                            Date debut
                                        </label>
                                        <input type="date" onChange={handleStartedDate} value={startAt}
                                               name="startDate" id="startDate" autoComplete="off" className="form-control" placeholder="Rechercher ..."
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group mt-3">
                                        <label htmlFor="endDate" className="text-dark">
                                            Date fin
                                        </label>
                                        <input type="date" onChange={handleEndedDate} value={endAt}
                                               name="endDate" id="endDate" autoComplete="off" className="form-control" placeholder="Rechercher ..."
                                        />
                                    </div>
                                </div>
                                <div className="col-md-1">
                                    <div className="form-group mt-3">
                                        <button onClick={handleBtns} className="mt-4 btn btn-primary">Filtrer</button>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group mt-4 d-flex float-end">
                                        <PrinterStation devise={"ALL"} param={param} type={"in"} endAt={endAt} startAt={startAt} critere={search} data={filteredConsumptions} />
                                    </div>
                                </div>
                            </div>

                            <hr/>
                            <table className="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col" colSpan="3">Plaque</th>
                                    <th scope="col">Chauffeur</th>
                                    <th scope="col">Motif</th>
                                    <th scope="col">Qté</th>
                                    <th scope="col">Type</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Options</th>
                                </tr>
                                </thead>
                                {!loading &&<tbody>
                                {paginatedConsumptions.map((consu) => (
                                    <tr key={consu.id}>
                                        <td>{counter++}</td>
                                        <td colSpan="3"><b className="text-success">{consu.plaque}</b></td>
                                        <td>{consu.driver}</td>
                                        <td>{consu.motif}</td>
                                        <td>{consu.quantity} Littres</td>
                                        <td>{consu.type}</td>
                                        <td>{Moment(consu.created_at).format("DD/MM/YYYY")}</td>
                                        <td>
                                            {/*<Link className="btn btn-sm btn-outline-primary mx-1" to={`/cashier/consu/edit/${consu.id}`}>*/}
                                            {/*    <i className="bi bi-pen-fill"></i>*/}
                                            {/*</Link>*/}
                                        </td>
                                    </tr>
                                ))
                                }

                                </tbody>}
                            </table>
                            {loading && <TableLoader width={300} height={350} />}

                            <br/>

                            {itemsPerPage < filteredConsumptions.length &&
                                <Pagination
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    length={filteredConsumptions.length}
                                    onPageChange={handleChangeCurrentPage}
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RapportMounthlyConsuption;
